// We persist the user's active Stack team id in localStorage so that
// reloading the page lands on the right tenant.

const KEY = 'cdvi-edge:active-stack-team-id';

export function getActiveStackTeamId(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setActiveStackTeamId(id: string | null): void {
  try {
    if (id) localStorage.setItem(KEY, id);
    else localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
